import AdditionalReport from "#/components/exam-results/additionalReportTab";
import AnswerKey from "#/components/exam-results/answerKey";
import DescriptiveAnswer from "#/components/exam-results/descriptiveAnswerTab";
import layoutStyles from "#/components/exam-results/Layout/styles.module.scss";
import { useNavigate, useParams, useSearchParams } from "@monta/router-react";
import clsx from "clsx";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import DownloadBtn from "../../DownloadBtn";
import { type Tab } from "../../types";
import Overall from "./overall";
import styles from "./styles.module.scss";

const ExamResultsType1View = () => {
  const params = useParams();
  const navigate = useNavigate();
  const tab = Number(params["tabId"]);
  const contentRef = useRef<HTMLDivElement>(null);
  const examTakingId = Number(params["examTakingId"]);
  const [searchParams] = useSearchParams();
  const isSimulator = searchParams.get("isSimulator");

  const tabs: Tab[] = [
    {
      title: "اطلاعات کلی",
      id: 1,
      component: <Overall ref={contentRef} />
    },
    {
      title: "کارنامه تکمیلی",
      id: 2,
      component: <AdditionalReport />
    },
    {
      title: "پاسخ تشریحی",
      id: 3,
      component: <DescriptiveAnswer />
    },
    {
      title: "کلید و پاسخ",
      id: 4,
      component: <AnswerKey />
    }
  ];

  const reactToPrintFn = useReactToPrint({
    contentRef: contentRef,
    documentTitle: "کارنامه"
  });

  return (
    <div className={styles["examResultsType1"]}>
      <div className={clsx(styles["examResultsType1__header"])}>
        <div className={layoutStyles["examResultsLayout__tabs"]}>
          {tabs.map((item) => {
            return (
              <button
                key={item.id + "btn"}
                className={clsx(
                  tab === item.id &&
                    layoutStyles["examResultsLayout__tabs--active"]
                )}
                onClick={() => {
                  navigate(
                    `/exam-results/type-1/${item.id}/${examTakingId}${isSimulator ? `?isSimulator=true` : ``}`
                  );
                }}
              >
                {item.title}
              </button>
            );
          })}
        </div>
        {tab === tabs[0].id && (
          <DownloadBtn
            onClick={() => {
              reactToPrintFn();
            }}
          />
        )}
      </div>
      <div className={styles["examResultsType1__content"]}>
        {(tabs[tab - 1] ?? tabs[0]).component}
      </div>
    </div>
  );
};

export default ExamResultsType1View;
